// @flow
import * as React from 'react';
import * as API from '../../api';
import Validators, { IValidatorPackage } from '../../Validators';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import CheckboxGroup from '../CheckboxGroup/CheckboxGroup';
import TextField from '../TextField/TextField';
import { withLocalize, Translate } from "react-localize-redux";

import './HearAbout.css';

interface IHearAboutProps {
    selectedLocationName: string;
    hearAboutData: API.IHearAboutData[];
    hearAbout: string[];
    otherEntry: string;
    handleClickBack: () => void;
    handleClickNext: () => void;
    updateHearAbout: (value: string) => void;
    updateOtherEntry: (value: string) => void;
}

interface IHearAboutState {
    deferErrors: boolean;
}

class HearAbout extends React.Component<IHearAboutProps, IHearAboutState> {
    validators: {
        [key: string]: IValidatorPackage[];
        hearAbout: IValidatorPackage[];
    };

    constructor(props: IHearAboutProps) {
        super(props);

        this.state = {
            deferErrors: true
        };

        this.validators = {
            hearAbout: [{
                validator: Validators.requiredArray,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            otherEntry: [{
                validator: Validators.passThrough,
                errorMessage: <Translate id="constants_js.noError"/>
            }],
        };
    }

    validate() {
        const validatorKeys = Object.keys(this.validators);
        for (let i = 0; i < validatorKeys.length; i++) {
            const prop = validatorKeys[i];
            const validators = this.validators[prop];
            for (let j = 0; j < validators.length; j++) {
                const validatorPackage = validators[j];
                if (validatorPackage.validator(this.props[prop]) === false) {
                    return false;
                }
            }
        }
        return true;
    }

    onChangeHearAbout = (value: string) => {
        let list = Array.from(this.props.hearAbout);
        if (list.includes(value)) {
            list.splice(list.indexOf(value), 1);
        } else {
            list.push(value);
        }
        // console.log(list);
        this.props.updateHearAbout(list);
    }

    onChangeOtherEntry = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.updateOtherEntry(e.currentTarget.value);
    }

    onClickBack = () => {
        this.props.handleClickBack();
    }

    onClickNext = () => {
        console.log("Next to Agreement Page");
        if (this.validate()) {
            this.props.handleClickNext();
        }
        else {
            this.setState({ deferErrors: false });
        }
    }

    render() {
        const methods = this.props.hearAboutData.map((hearAbout) => {
            return hearAbout.method;
        });
        methods.push('Other');
        return (
            <div className={'HearAbout'}>
                <Header
                    header={this.props.selectedLocationName}
                    subHeader={''}
                />
                <CheckboxGroup
                    label={<Translate id="hear_about_js.label_checkbox_group"/>}
                    selectedValue={this.props.hearAbout}
                    handleChange={this.onChangeHearAbout}
                    optionLabels={methods}
                    optionValues={methods}
                    required={true}
                    validators={this.validators.hearAbout}
                    deferErrors={this.state.deferErrors}
                />
                {
                this.props.hearAbout.includes('Other') && 
                <TextField
                    label={<Translate id="hear_about_js.label_text_field"/>}
                    value={this.props.otherEntry}
                    handleOnChange={this.onChangeOtherEntry}
                    required={false}
                    validators={this.validators.otherEntry}
                    deferErrors={this.state.deferErrors}
                />}
                <Footer
                    nextEnabled={this.state.deferErrors === true || this.validate()}
                    handleClickBack={this.onClickBack}
                    handleClickNext={this.onClickNext}
                    nextText={<Translate id="footer_js.next"/>}
                    backText={<Translate id="footer_js.back"/>}
                />
            </div>
        );
    }
}

export default withLocalize(HearAbout);
// export default HearAbout;
